import "core-js/modules/es6.object.assign";
import { theme, withProp } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import { oneOfType, number, string } from 'prop-types';
import { a as numberToPx } from './chunk-afcdbe83.js';
import './chunk-1128464e.js';
import Box from './Box.js';
import { a as getSelector } from './chunk-c3683479.js';
var CardFit = styled(Box).withConfig({
  displayName: "CardFit",
  componentId: "sc-17ckqrf-0"
})(["", ";"], theme("CardFit"));
var CardFit$1 = as("div")(CardFit);
var Card = styled(Box).withConfig({
  displayName: "Card",
  componentId: "sc-19jv5xv-0"
})(["display:inline-block;&& > *:not(", "){margin:", ";}", ";"], getSelector(CardFit$1), withProp("gutter", numberToPx), theme("Card")); // @ts-ignore

Card.propTypes = {
  gutter: oneOfType([number, string])
};
Card.defaultProps = {
  gutter: "1rem",
  opaque: true,
  palette: "background",
  tone: -1
};
var Card$1 = as("div")(Card);
var index = Object.assign(Card$1, {
  Fit: CardFit$1
});
export default index;